import {
  generalTerm,
} from './pl.shared.ts';

import npmTranslation from '@/generated/npm/locales/pl.npm.ts';
import {
  TComponentNpmKeys,
  TComponentNpmValue,
} from '@/types/openapi-type.ts';

const RBBEProcessMode_String: Record<TComponentNpmValue<'RBBEProcessMode_String'>, string> = {
  STANDBY: 'Czuwanie',
  PROCESS: 'Proces',
  MAINTENANCE: 'Konserwacja',
  NO_PROCESS: 'Brak procesu',
  EMERGENCY: 'Nagły wypadek',
  ABORT: 'Przerwij',
  PREHEAT: 'Rozgrzej',
  PURGE: 'Płukanie',
  TRANSFER_IN: 'Przelew',
  TRANSFER_OUT: 'Przenieś na zewnątrz',
  FINISHED: 'Gotowy',
  ERROR: 'Błąd',
};

const LoadJobDto: Record<keyof TComponentNpmValue<'LoadJobDto'>, string> = {
  recipe_code: generalTerm.recipe,
  customer_code: 'Kod klienta',
  customer_name: 'Nazwa klienta',
  operator_name: 'Operator',
  shop_order: 'Zamówienie w sklepie',
  part_numbers: 'Numery części (rozdzielone przecinkami)',
  part_count: 'Przelicz',
  job_start_time: 'Czas rozpoczęcia',
  comment: 'Komentarz',
};

const RecipeListEntryDTO: Record<keyof TComponentNpmValue<'RecipeListEntryDTO'>, string> = {
  recipe_code: generalTerm.recipe,
  recipe_description: generalTerm.description,
  protected: 'Chroniony',
};

const RecipeDTO: Partial<TComponentNpmKeys<'RecipeDTO', Record<string, string> | string>> = {
  description: generalTerm.description,
  duration_min: npmTranslation.resourceId[1028],
};

const StageDTO: Partial<TComponentNpmKeys<'StageDTO', Record<string, string> | string>> = {
  stage_no: '#',
  name: generalTerm.displayName,
  EndCond: npmTranslation.resourceId[1035],
};

export default {
  LoadJobDto,
  RBBEProcessMode_String,
  RecipeListEntryDTO,
  RecipeDTO,
  StageDTO,
};
